import { t } from '@hefe/i18n';
import { userState } from '@hefe/store';
import { greeting } from '@hefe/utils';
import { Row, Typography } from 'antd';
import { useSelector } from 'react-redux';
import UpcomingUserEventsComponent from '../../../events/components/upcoming-user-events/upcoming-user-events';
import TutorialsDashboardComponent from '../../../tutorials/components/tutorials-dashboard/tutorials-dashboard.component';
import './dashboard.module.scss';

//const ResponsiveReactGridLayout = WidthProvider(Responsive);

/* eslint-disable-next-line */
export interface DashboardProps {}

export function Dashboard(props: DashboardProps) {
  const user = useSelector(userState).user;

  return (
    <div>
      <Row justify="space-between">
        <Typography.Title style={{ marginLeft: 10 }} level={4}>
          {t(greeting())} {user?.firstname}!
        </Typography.Title>
      </Row>
      <div style={{ marginTop: 15, marginBottom: 30 }}>
        <TutorialsDashboardComponent />
      </div>
      <div style={{ marginTop: 15 }}>
        <UpcomingUserEventsComponent />
      </div>
    </div>
  );
}

/*
INFO BOX

<Row justify="space-between">
        <Alert
          style={{ backgroundColor: '#E6F4FF' }}
          message={t('update.title', { version: '1.1.0' })}
          description={
            <Space direction="vertical">
              <Typography.Text>{t('update.message_1_1_0')}</Typography.Text>
            </Space>
          }
        />
      </Row>

<Row justify="space-between">
        <Alert
          style={{ backgroundColor: '#E6F4FF' }}
          message={t('update.title', { version: '1.0.0' })}
          description={
            <Space direction="vertical">
              <Typography.Text>{t('update.message_1_0_0')}</Typography.Text>
              <Typography.Text>
                <a href="/legacy" target="_blank">
                  Backcourt 0.21.1
                </a>
              </Typography.Text>
              <Typography.Text>
                <a href="/support" target="_blank">
                  Support
                </a>
              </Typography.Text>
            </Space>
          }
        />
      </Row>
*/

export default Dashboard;
